<template>
  <div
    class="cloudprint"
    >
    <div class="cloudprint-header grey darken-3">
      <slot name="header"/>
    </div>
    <div class="cloudprint-body">
      <div class="cloudprint-body-list">
        <slot name="list"/>
      </div>
      <div class="cloudprint-body-details" :style="$slots.details?'width: 300%; border-left: solid 1px white;':''">
        <slot name="details"/>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: [],
    data: () => ({
    }),
  }
</script>
<style>
  .cloudprint {
    position: relative;
    height: 100%;
    overflow: hidden;
  }
  .cloudprint-header {
    position: relative;
    display: flex;
    height: 46px;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    overflow: hidden;
  }
  .cloudprint-body {
    position: relative;
    height: calc(100% - 46px);
    display: flex;
    overflow: hidden;
  }
  .cloudprint-body-list {
    width: 100%;
    height: 100%;
    transition: width 0.2s ease-in-out;
    overflow: auto;
  }
  .cloudprint-body-details {
    position: relative;
    width: 0px;
    height: 100%;
    transition: width 0.2s ease-in-out;
    overflow: hidden;
  }
</style>
